import api from '../api';

export default {
    getFeedbackContact: payload => api.getFeedbackContact(payload)
}



// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/right-toolbar/model/service/feedback.js